import "liquid-ajax-cart";

export default {
    name: 'global',
    store() {
        return {
            isMobileMenuVisible: false,
            isMinicartVisible: false,
            openSearch: false,
            openFilters: false,
            // isPredictiveSearchVisible: false,
            isWindowScrolled: false,
            cart: null,
            cart_count: 0,
            lastAddedProduct: null,
            body: "",
            scrollTopLock: 0,
            showPasswordReset: false,
            wishlistItems: [],
            onWishlistLoad: true,
            listId: '',
            swat: '',


            init() {
                window.liquidAjaxCart.conf("updateOnWindowFocus", false);
                window.liquidAjaxCart.conf("quantityTagAllowZero", true);
                window.addEventListener('scroll', this.onWindowScrollHandler.bind(this))
                // const cartOpen = new URLSearchParams(window.location.search).get('open');


                let textItems = document.querySelectorAll('[data-lists-tables]');
                if(textItems != null) {
                    textItems.forEach(item => {
                        let lists = item.querySelectorAll('ul, ol');
                        lists.forEach(list => {
                            list.querySelectorAll('li').forEach(li => {                            
                                // Split text at | and use flex justify-between
                                const text = li.textContent.trim();
                                if (text.includes('|')) {
                                    const parts = text.split('|').map(part => part.trim());
                                    li.innerHTML = `<span>${parts[0]}</span><span>${parts[1]}</span>`;
                                }
                            });
                        });
                    });
                }

                // if(cartOpen == 'true') {
                //     this.isMinicartVisible = true;
                // }

                if(window.location.href.indexOf("#recover") != -1) {
                    this.showPasswordReset = true;
                }

                this.initLiquidAJaxCart();

                if (!window.SwymCallbacks) {
                    window.SwymCallbacks = [];
                }
                window.SwymCallbacks.push(this.onSwymLoadCallback);

                this.body = document.querySelector("body");
            },

            get bodyClasses() {
                let classes = []

                if (this.isMobileMenuVisible) {
                    classes.push('mobile-menu-visible')
                }
                if (this.isMinicartVisible) {
                    classes.push('cart-visible')
                }
                return classes || ''
            },

            openMobileMenu() {
                this.isMobileMenuVisible = true
                this.enableBodyScrollLock()
            },

            closeMobileMenu() {
                this.isMobileMenuVisible = false
                this.disableBodyScrollLock()
            },

            toggleMobileMenu() {
                this.isMobileMenuVisible = !this.isMobileMenuVisible

                if(this.isMobileMenuVisible) {
                    this.enableBodyScrollLock()
                } else {
                    this.disableBodyScrollLock()
                }
            },

            initLiquidAJaxCart() {
                // document.addEventListener("liquid-ajax-cart:init", (event) => {
                //     this.cart = window.liquidAjaxCart.cart;
                // });
                
                // document.addEventListener("liquid-ajax-cart:request-end", (event) => {
                //     setTimeout(() => {
                //         const { requestState, cart, previousCart, sections } = event.detail;
    
                //         if (requestState.requestType === 'add') {
                //             if (requestState.responseData?.ok) {
                //                 // this.isMinicartVisible = true;
                //                 // this.enableBodyScrollLock();
                //             }
                //         }
                //         console.log(cart);
                //         this.cart = cart;
                //         console.log(this.cart);
                //         this.cart_count = this.cart.item_count
                //     }, 1000);

                // });

                document.addEventListener("liquid-ajax-cart:init", (event) => {
                    this.cart = window.liquidAjaxCart.cart;
                });

                document.addEventListener("liquid-ajax-cart:request-end", (event) => {
                    const { requestState, cart, previousCart, sections } = event.detail;

                    if (requestState.requestType === 'add') {
                        if (requestState.responseData?.ok) {
                            this.isMinicartVisible = true;
                            this.enableBodyScrollLock();
                        }
                    }

                    this.cart = cart
                    this.cart_count = this.cart.item_count
                });
            },

            onWindowScrollHandler() {
                const isScrolled = window.scrollY > 0

                this.isWindowScrolled = isScrolled
                document.body.classList[isScrolled ? 'add' : 'remove']('scrolled')
            },

            enableBodyScrollLock() {
                this.scrollTopLock =
                    document.documentElement.scrollTop || document.body.scrollTop;
                this.body.style.overflow = "hidden";
                this.body.style.position = "fixed";
                this.body.style.top = `-${this.scrollTopLock}px`;
                this.body.style.width = "100%";
            },
        
            disableBodyScrollLock() {
                this.body.style.removeProperty("overflow");
                this.body.style.removeProperty("position");
                this.body.style.removeProperty("top");
                this.body.style.removeProperty("width");
                window.scrollTo(0, this.scrollTopLock);
            },


            hexToRgb(hex) {
                var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
                hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                  return r + r + g + g + b + b;
                });
              
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                
                return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null
            },

            checkTextColor(color, element) {
                let rgb = this.hexToRgb(color);
                let black = [55, 56, 40];

                if(rgb != null) {
                    if(this.contrast(rgb, black) > 4.5) {
                        element.classList.add('text-black');
                    } else {
                        element.classList.add('text-white');
                    }                
                }
            },

            luminance(r, g, b) {
                const red = 0.2126;
                const green = 0.7152;
                const blue = 0.0722;

                var a = [r, g, b].map((v) => {
                  v /= 255;
                  return v <= 0.03928
                    ? v / 12.92
                    : Math.pow((v + 0.055) / 1.055, 2.4);
                });
                return a[0] * red + a[1] * green + a[2] * blue;
            },
              
            contrast(rgb1, rgb2) {
                var lum1 = this.luminance(...rgb1);
                var lum2 = this.luminance(...rgb2);
                var brightest = Math.max(lum1, lum2);
                var darkest = Math.min(lum1, lum2);
                return (brightest + 0.05) / (darkest + 0.05);
            },

            changeCart(id, qty = 1) {
                const body = {
                  id: id,
                  quantity: Number(qty)
                }
                
                const options = {
                  firstCallback: function(requestState) {
                    /**
                     * This callback function will be called first after the request is performed,
                     * thus none of request subscribers knows the result of the request,
                     * thus Cart state is not updated yet, sections are not updated yet,
                     * everything is not updated yet.
                     */
                  },
                  lastCallback: function(requestState) {
                    /**
                     * This callback-function will be called the latest
                     * among request subscribers,
                     * thus all the request subscribers are executed,
                     * thus Cart state is updated, sections are updated,
                     * everything is updated.
                     */
                  },
                  info: {
                    /**
                     * Any additional data you want to attach to the Request state object.
                     * Don't use the "initiator" and the "cancel" keys.
                     */
                    // myParameter: 'value'
                  },
                
                  // whether the request should go to the beginning of the queue rather than to the end
                  important: false
                }
                
                liquidAjaxCart.change(body, options);
            },

            syncCartNote(note) {
                if (!window.liquidAjaxCart?.update) return;
                window.liquidAjaxCart.update({ note: String(note ?? '').trim() }, {});
            },

            goCheckout(checkoutUrl, note) {
                const url = checkoutUrl || '/checkout';
                const n = String(note ?? '').trim();
                if (!window.liquidAjaxCart?.update) return void window.location.assign(url);
                window.liquidAjaxCart.update(
                    { note: n },
                    { important: true, lastCallback: () => window.location.assign(url) }
                );
            },

            onSwymLoadCallback(swat) {
                // Please make all SWYM-related API calls inside this function.
                // You can use the swat argument within this scope.
                if (swat) {
                    window.swat = swat;
                    window.Alpine.store('global').getWishlist();
                }
            },

            getWishlist() {
                let onSuccess = (lists) => {              
                    if (lists.length > 0) {
                        let listConfig = {
                            "lid": lists[0].lid, // lid
                        };

                        window.Alpine.store('global').listId = lists[0].lid;
                        
                        // Define success callback
                        let onSuccess = function(listDetails) {
                            // Successfully fetched list details
                            if (listDetails.items !== null) {
                                window.Alpine.store('global').wishlistItems = listDetails.items;
                            }
                            window.Alpine.store('global').checkInWishlist();
                            
                            // console.log("Successfully fetched List details", listDetails);
                        }
                        
                        // Define error callback
                        let onError = function(error) {
                            // Error is an xhrObject
                            console.log("Error while fetching List details", error);
                        }
                        
                        // Call `fetchListDetails` with the above callbacks and listConfig
                        window.swat.fetchListDetails(listConfig, onSuccess, onError);

                        setTimeout(() => {
                            this.onWishlistLoad = false;
                        }, 200);

                    } else {
                        window.Alpine.store('global').makeWishlist();

                        setTimeout(() => {
                            this.onWishlistLoad = false;
                        }, 200);
                        // window.Alpine.store('global').checkInWishlist();
                    }
                }
              
                // Define error callback
                let onError = (error) => {
                    console.log("Error while fetching all Lists", error);
                }

                window.swat.fetchLists({
                    callbackFn: onSuccess,
                    errorFn: onError
                });
            },

            makeWishlist() {
                let listConfig = {
                  'lname': 'Wishlist'
                };
                
                // Define success callback
                let onSuccess = function(newList) { 
                    window.Alpine.store('global').getWishlist();
                }
                
                // Define error callback
                let onError = function(error) {
                    console.log("Error while creating a List", error);
                }
                
                // Create a new list with the above callbacks and config
                window.swat.createList(listConfig, onSuccess, onError);
            },

            checkInWishlist() {
                const items = document.querySelectorAll('[data-wishlist-item]');
                [...items].forEach(item => {
                    const productId = item.dataset.wishlistItem;
                    const inWishlist = this.wishlistItems.find(it => {
                        return it.empi.toString() === productId;
                    });
      
                    if (inWishlist) {
                        if(item.querySelector('[data-wishlist-add]') != null) {
                            item.querySelector('[data-wishlist-add]').classList.add('hidden', 'inactive');
                        }
                        if(item.querySelector('[data-wishlist-remove]') != null) {
                            item.querySelector('[data-wishlist-remove]').classList.remove('hidden', 'inactive');
                        }
                    } else {
                        if(item.querySelector('[data-wishlist-remove]') != null) {
                            item.querySelector('[data-wishlist-remove]').classList.add('hidden', 'inactive');
                        }
                        if(item.querySelector('[data-wishlist-add]') != null) {
                            item.querySelector('[data-wishlist-add]').classList.remove('hidden', 'inactive');
                        }
                    }
                })
            },

            addToWishlist(empi, epi, du){
                let product = {
                    epi: epi,
                    empi: empi,
                    du: du,
                };

                let onSuccess = function (addedListItem){
                    window.Alpine.store('global').getWishlist();
                }

                let onError = function (error){
                    console.log("Error while adding the Product to the List", error);
                }

                window.swat.addToList(this.listId, product, onSuccess, onError);
            },

            removeFromWishlist(empi, epi, du) {
                let product = {
                    epi: epi,
                    empi: empi,
                    du: du,
                };

                let onSuccess = function(deletedProduct) {
                    window.Alpine.store('global').getWishlist();
                }

                let onError = function(error) {
                    console.log("Error while deleting the Product", error);
                }

                window.swat.deleteFromList(this.listId, product, onSuccess, onError);
            },
        }
    }
}